
























































import { Component, Ref, Vue } from 'vue-property-decorator'

export type AcaoDepoisDaBipagem = 'repetir' | 'produto' | 'fechar'

export type ParametrosDoProximoItem = {
	descricaoDoItem: string
}

@Component
export default class DialogoDeProximoItemDaPreVenda extends Vue {
	@Ref() botaoRepetir!: Vue
	@Ref() botaoProduto!: Vue
	@Ref() botaoFechar!: Vue

	mostra = false
	descricaoDoItem = ''

	private resolver: ((acao: AcaoDepoisDaBipagem) => void) | null = null
	private temporizadoresDeFoco: ReturnType<typeof setTimeout>[] = []

	mostrar(parametros: ParametrosDoProximoItem): Promise<AcaoDepoisDaBipagem> {
		// se sobrou um pedido pendente, ele é encerrado como se o operador tivesse fechado
		this.responder('fechar')

		this.descricaoDoItem = parametros.descricaoDoItem
		this.mostra = true

		// o v-dialog puxa o foco para si depois de abrir, então o botão é focado de novo até
		// o diálogo estabilizar, para o Enter valer como o primeiro botão
		this.$nextTick(() => this.focarPrimeiroBotao())
		this.temporizadoresDeFoco = [120, 320].map(atraso => setTimeout(() => this.focarPrimeiroBotao(), atraso))

		return new Promise(resolve => {
			this.resolver = resolve
		})
	}

	responder(acao: AcaoDepoisDaBipagem) {
		this.temporizadoresDeFoco.forEach(temporizador => clearTimeout(temporizador))
		this.temporizadoresDeFoco = []

		const resolver = this.resolver
		this.resolver = null
		this.mostra = false
		if (resolver) resolver(acao)
	}

	/**
	 * Setas e Esc. O evento vem do próprio v-dialog, e não como listener nativo: o conteúdo do
	 * diálogo é montado fora do elemento raiz do componente, então um @keydown.native nunca o
	 * veria. O Enter fica com o comportamento nativo do botão em foco.
	 */
	aoTeclar(evento: KeyboardEvent) {
		if (evento.key === 'Escape' || evento.key === 'Esc') {
			evento.preventDefault()
			this.responder('fechar')
			return
		}

		const passos: Record<string, number> = { ArrowDown: 1, ArrowUp: -1 }
		const passo = passos[evento.key]
		if (passo === undefined) return

		evento.preventDefault()
		this.moverFoco(passo)
	}

	/** Botões na ordem em que aparecem na tela, um embaixo do outro. */
	private get botoesNavegaveis(): Vue[] {
		return [this.botaoRepetir, this.botaoProduto, this.botaoFechar]
	}

	/** Anda entre os botões com as setas, sem dar a volta na lista. */
	private moverFoco(passo: number) {
		const botoes = this.botoesNavegaveis
		const atual = botoes.findIndex(botao => botao?.$el === document.activeElement)
		if (atual < 0) {
			this.focarPrimeiroBotao()
			return
		}

		const destino = atual + passo
		if (destino < 0 || destino >= botoes.length) return

		const elemento = botoes[destino]?.$el as HTMLElement | undefined
		elemento?.focus()
	}

	private focarPrimeiroBotao() {
		const elemento = this.botaoRepetir?.$el as HTMLElement | undefined
		if (!elemento) return
		// se o operador já escolheu um botão com as setas ou com o Tab, o foco é dele
		if (document.activeElement instanceof HTMLButtonElement) return
		elemento.focus()
	}
}
